export enum ActionTypeEnum {
  CREATE = 'create',
  ADD = 'add',
  VOUCHER = 'voucher'
}
